<script setup lang="ts">
import { MtdTypography } from '@paygine/mtd-uikit'

import { CheckIcon, EditIcon, SbpIcon } from '@/shared/icons'

const props = defineProps<{
    bank: {
        bank_name: string
        id: number
    }
    canEdit: boolean
    checked?: boolean
}>()

const emit = defineEmits<{
    'payMethod:change': []
}>()
</script>

<template>
    <div class="pay-method">
        <div class="pay-method__icon">
            <img
                src="/img/scb-logo-small.svg"
                alt=""
            />
        </div>

        <div class="pay-method__name">
            <MtdTypography
                tag="span"
                variant="body-2"
                style="font-weight: 500"
                >{{ props.bank.bank_name }}</MtdTypography
            >
            <div class="pay-method__sort">
                <SbpIcon />
                <MtdTypography
                    tag="span"
                    class="pay-method__sbp"
                    variant="body-2"
                    >CБП</MtdTypography
                >
            </div>
        </div>

        <EditIcon
            v-if="props.canEdit"
            class="pay-method__edit"
            @click="emit('payMethod:change')"
        />

        <CheckIcon
            v-if="props.checked && !props.canEdit"
            class="pay-method__checked"
        />
    </div>
</template>

<style src="./VPayMethod.scss" lang="scss"></style>
